<template>
  <m-card-item
    :icon="icon"
    :tooltip="tooltip"
    tooltip-placement="left"
    @click="$emit('toggle')"
  >
    {{ label }}
    <template #right>
      <m-switch
        :value="value"
        small
      />
    </template>
  </m-card-item>
</template>

<script setup>
defineProps({
  icon: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  value: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: String,
    default: '',
  },
});

defineEmits(['toggle']);
</script>
